import { Outlet } from 'react-router-dom';
import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import ScrollToTop from '@/components/base/ScrollToTop';
import SEOMeta from '@/components/base/SEOMeta';

export default function Layout() {
  return (
    <>
      <SEOMeta />
      <ScrollToTop />
      <Navbar />
      <Outlet />
      <Footer />
    </>
  );
}